import React from 'react';
import RootApp from './app/index';
import 'bootstrap';
import 'bootbox';

export default function App() {
  return (
    <RootApp />
  )
}